import React, { memo, useState, useEffect } from 'react';
import Book from '@material-ui/icons/Book';

// core components
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from 'components/CustomButtons/Button';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { wsCreate } from 'services/WService';
import { useModal } from 'hooks/useModal';
import { Edit } from '@material-ui/icons';
import Modal from 'components/Tvendo/Common/ModalBase';
import { TextField } from '@material-ui/core';

// Permisos
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const AvgPriceModal = memo(function (props) {
  const { model, setOpen, setInvalidStocks } = props;
  const [AvgPrice, setAvgPrice] = useState(0);
  const [processing, setProcessing] = useState(false);

  async function updateAvgPrice() {
    setProcessing(true);
    let res = await wsCreate('logi/stock-revaluation', {
      WhsCode: model?.WhsCode,
      ItemCode: model?.ItemCode,
      AvgPrice,
    });
    setProcessing(false);
    if (res.success) {
      setOpen({ open: false });
      window.alert(res.message);
      setInvalidStocks((stocks) => {
        let newStocks = [...stocks];
        let index = newStocks.findIndex(
          (stock) => stock.WhsCode === model?.WhsCode && stock.ItemCode === model?.ItemCode,
        );
        if (index > -1) {
          newStocks.splice(index, 1);
        }
        return newStocks;
      });
    } else {
      window.alert(res.message);
    }
  }

  useEffect(() => {
    if (model.open === true) {
      setAvgPrice(0);
    }
  }, [model]);

  return (
    <Modal
      model={model}
      setOpen={setOpen}
      title="Actualizar AvgPrice 0"
      disabledSave={processing}
      onSubmit={() => {
        updateAvgPrice();
        throw new Error('');
      }}
    >
      {model.WhsCode !== undefined && (
        <>
          <h4>
            Almacén: ({model.WhsCode}) {model.WhsName}
          </h4>
          <h4>
            Producto: ({model.ItemCode}) {model.ItemName}
          </h4>
          <TextField
            label="AvgPrice"
            value={AvgPrice}
            inputProps={{ min: 0.01, step: 0.01 }}
            type="number"
            onChange={(e) => {
              let value = e.target.value;
              if (value == '') value = 0;
              else value = parseFloat(value);
              setAvgPrice(value);
            }}
          />
        </>
      )}
    </Modal>
  );
});

function InvalidAvgPrice(props) {
  const { invalidStocks, setInvalidStocks } = props;
  const [avgPriceModel, setOpen] = useModal();

  return (
    <Card>
      <AvgPriceModal model={avgPriceModel} setOpen={setOpen} setInvalidStocks={setInvalidStocks} />
      <CardHeader icon>
        <CardIcon color="primary">
          <Book />
        </CardIcon>
        <div id="avgprice">
          <h4>Productos con Precio promedio 0</h4>
        </div>
      </CardHeader>
      <CardBody>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell width={50}>Almacén</TableCell>
                <TableCell width={100}>Producto</TableCell>
                <TableCell width={30}>Stock</TableCell>
                <AllowedGuard permission={ConstantPermissions.LOGI_STOCKS_REVALUATE}>
                  <TableCell width={30}></TableCell>
                </AllowedGuard>
              </TableRow>
            </TableHead>
            <TableBody>
              {invalidStocks.map((stock, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>{stock.WhsName}</TableCell>
                    <TableCell>{`${stock.ItemCode} / ${stock.ItemName}`}</TableCell>
                    <TableCell>{parseInt(stock.OnHand)}</TableCell>
                    <AllowedGuard permission={ConstantPermissions.LOGI_STOCKS_REVALUATE}>
                      <TableCell>
                        <Button
                          justIcon
                          round
                          color="warning"
                          onClick={() => {
                            setOpen(stock);
                          }}
                        >
                          <Edit />
                        </Button>
                      </TableCell>
                    </AllowedGuard>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  );
}

export default InvalidAvgPrice;
